<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Crear Acuerdo Comercial</h4>
  <button
    id="details-modal-close"
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="d('Cross')"
  ></button>
</div>
<div class="modal-body">
  <div>
    <form [formGroup]="createForm">
      <div class="row">
        <div class="form-group col-sm-2 col-lg-5">
          <label for="sapID">Sap Id</label>
          <input
            type="text"
            id="sapID"
            formControlName="sapID"
            placeholder="Ejemplo: 91138"
            class="form-control"
          />
          <div *ngIf="sapID.invalid && (sapID.dirty || sapID.touched)">
            <small class="form-text text-muted">
              {{ sapID.errors?.['sapIdNotFound'] }}
            </small>
          </div>
        </div>
        <div class="form-group col-sm-2 col-lg-6">
          <label for="type">Tipo de acuerdo comercial</label>
          <select id="type" formControlName="type" class="form-select">
            <option selected disabled hidden value="" selected>
              Seleccionar...
            </option>
            <option *ngFor="let type of ACTYPES" [ngValue]="type.valueId">
              {{ type.valueToDisplay }}
            </option>
          </select>
        </div>
      </div>

      <div class="row" *ngIf="hasGuaranteed">
        <div class="form-group col-sm-2 col-lg-5">
          <label for="guaranteed">Monto garantizado </label>
          <input
            type="text"
            id="guaranteed"
            formControlName="guaranteed"
            placeholder="1.000.000"
            inputmode="numeric"
            class="form-control"
          />
        </div>
        <div class="form-group col-sm-2 col-lg-6">
          <label for="currency">Moneda</label>
          <select id="currency" formControlName="currency" class="form-select">
            <option selected disabled hidden value="" selected>
              Seleccionar...
            </option>
            <option
              *ngFor="let currency of currencies"
              [ngValue]="currency.value"
            >
              {{ currency.valueToDisplay }}
            </option>
          </select>
        </div>
      </div>

      <div *ngIf="hasAdditionalPercent" class="row">
        <div class="form-group col-sm-2 col-lg-5">
          <label for="additionalPercentage">Porcentaje variable </label>
          <div>
            <input
              type="text"
              min="1"
              max="99"
              id="additionalPercentage"
              inputmode="numeric"
              formControlName="additionalPercentage"
              placeholder="10"
              class="form-control"
            />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-sm-2 col-lg-5">
          <label for="startDate">Fecha de Inicio</label>
          <input
            type="date"
            id="startDate"
            formControlName="startDate"
            class="form-control"
          />
        </div>
        <div class="form-group col-sm-2 col-lg-5">
          <label for="endDate">Fecha Fin</label>
          <input
            type="date"
            id="endDate"
            formControlName="endDate"
            class="form-control"
          />
        </div>
      </div>
    </form>

    <form [formGroup]="workShiftsForm">
      <div>
        <h4>Turnos contractuales</h4>
        <div class="row">
          <div
            class="form-group col-sm-2 col-lg-3"
            [formGroupName]="'startTime'"
          >
            <label for="startHour">Hora de Inicio</label>
            <div class="d-flex align-items-center">
              <select
                id="startHour"
                class="form-control"
                formControlName="startHour"
              >
                <option *ngFor="let hour of hours" [value]="hour">
                  {{ hour < 10 ? "0" + hour : hour }}
                </option>
              </select>

              <span style="font-weight: bold; font-size: 1.2rem">:</span>

              <select
                id="startMinute"
                class="form-control"
                formControlName="startMinute"
              >
                <option *ngFor="let minute of minutes" [value]="minute">
                  {{ minute === 0 ? "00" : minute }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-group col-sm-2 col-lg-4">
            <label for="duration">Duración (horas) </label>
            <select
              id="duration"
              formControlName="duration"
              class="form-select"
            >
              <option selected disabled hidden value="" selected>
                Seleccionar...
              </option>
              <option *ngFor="let duration of durations" [ngValue]="duration">
                {{ duration }} Horas
              </option>
            </select>
          </div>

          <div formGroupName="days" class="days-checkboxes col-sm-2 col-lg-4">
            <div class="day" *ngFor="let day of days">
              <label>
                {{ day.valueToDisplay }}
              </label>
              <input type="checkbox" [formControlName]="day.value" />
            </div>
          </div>
          <div
            *ngIf="showCreate()"
            class="form-group col-sm-2 col-lg-1 add-work"
            [ngClass]="{ 'invalid-add-work': workShiftsForm.invalid }"
          >
            <span
              (click)="addWorkShift()"
              style="font-size: 36px"
              class="material-symbols-outlined"
            >
              add_circle
            </span>
          </div>
        </div>

        <div *ngIf="hasError" class="text-center">
          <p class="error-text">
            El turno contractual supera las 24 horas o se traslapa con otro
            turno registrado
          </p>
        </div>

        <div>
          <table
            *ngIf="listOfWorkShifts.length > 0 && !isValidating"
            class="table table-bordered table-striped"
          >
            <caption style="display: none">
              turnos a ingresar
            </caption>
            <thead>
              <tr>
                <th
                  colspan="10"
                  class="text-center"
                  id="ac-create-work-shift-title"
                >
                  turnos a ingresar
                </th>
              </tr>
              <tr>
                <th id="ac-create-work-shift-start">Inicio</th>
                <th class="text-center" id="ac-create-work-shift-duration">
                  Duración
                </th>
                <th
                  class="text-center"
                  id="ac-create-work-shift-day"
                  *ngFor="let day of days"
                >
                  {{ day.valueToDisplay }}
                </th>
                <th id="ac-create-work-shift-acctions"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let shift of listOfWorkShifts; let i = index">
                <td>
                  <strong>{{ shift.startTime.slice(0, 5) }}</strong>
                </td>
                <td class="text-center">
                  <strong>{{ shift.duration }}</strong>
                </td>
                <td class="text-center" *ngFor="let day of days">
                  <div class="d-flex flex-wrap gap-3 justify-content-center">
                    <div class="text-center" style="width: 10px">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        [id]="
                          'day-' + i + '-' + day.value + shift.days[day.value]
                        "
                        [checked]="shift.days[day.value]"
                        disabled
                      />
                    </div>
                  </div>
                </td>
                <td>
                  <span
                    (click)="removeWorkShift(i)"
                    class="material-symbols-outlined deleteWork"
                  >
                    delete
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="row">
            <div class="text-center my-5" *ngIf="isValidating">
              <app-spinner
                message="Validando Turnos Contractuales"
              ></app-spinner>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div>
    <p>
      El acuerdo comercial quedará pendiente de aprobación automáticamente.<br />
    </p>
  </div>
</div>

<div class="modal-footer">
  <button
    id="cisterna-details-update-attr-modal-cancel"
    type="button"
    class="btn btn-danger"
    (click)="d('Cancel')"
  >
    Cancelar
  </button>
  <button
    id="cisterna-details-update-attr-modal-accept"
    type="button"
    [disabled]="createForm.invalid || !entity || listOfWorkShifts.length < 1"
    class="btn btn-primary"
    (click)="c('Accept')"
  >
    Aceptar
  </button>
</div>
